"use client";

import { Map, Marker } from "@vis.gl/react-google-maps";
import { use } from "react";

import { Context } from "./context";

export function PlaceMap({
  location,
}: {
  location: { latitude: number; longitude: number };
}) {
  const { active } = use(Context);
  const _location = active?.googlePlace?.location ?? location;
  return (
    <div className="aspect-square w-full overflow-hidden rounded-xl">
      <Map
        center={{
          lat: _location.latitude,
          lng: _location.longitude,
        }}
        defaultZoom={16}
      >
        <Marker
          position={{
            lat: _location.latitude,
            lng: _location.longitude,
          }}
        />
      </Map>
    </div>
  );
}
